import React from 'react';
import { MapTilesTabsStyles } from './styles/MapTilesTabs.styles';
import { useDispatch } from 'react-redux';
import { setMapTileUrlState } from '../../../../../app/redux/slices/mapTileUrlSlice';
import { theme } from '../../../../../core/theme/theme';

interface MapTilesTabsDropdownProps {
    toggleButtons: any;
    isPicked: boolean;
    setPickedValue: React.Dispatch<React.SetStateAction<number>>;
    setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
    // setMapTileUrl: any;
}

const MapTilesTabsDropdown: React.FC<MapTilesTabsDropdownProps> = ({
    toggleButtons,
    isPicked,
    setPickedValue,
    setIsActive,
}) => {
    const dispatch = useDispatch();

    window.addEventListener('click', function (e) {
        //@ts-ignore
        if (document.getElementById('map-tiles-tabs') && !document.getElementById('map-tiles-tabs').contains(e.target)) {
            setPickedValue(0);
            setIsActive(false);
        }
    });

    const handleMouseOver = (id: string) => {
        (document.getElementById(`${id}`) as HTMLInputElement).style.backgroundColor = theme.colors.hover_color;
    };
    const handleMouseLeave = (id: string) => {
        (document.getElementById(`${id}`) as HTMLInputElement).style.backgroundColor = theme.colors.default;
    };

    return toggleButtons.map((button: any) => {
        return (
            <button
                key={button.value}
                id={`${button.text}`}
                onClick={() => {
                    dispatch(setMapTileUrlState(button.link));
                    setPickedValue(0);
                    setIsActive(false);
                }}
                onMouseOver={() => handleMouseOver(button.text)}
                onMouseLeave={() => handleMouseLeave(button.text)}
                style={MapTilesTabsStyles(isPicked).DropdownOptions}
            >
                {button.text}
            </button>
        );
    });
};

export default MapTilesTabsDropdown;
